import gql from 'graphql-tag';

import { exportFragment } from './exports.queries';

export const GET_VENDOR_EXPORTS_QUERY = gql`
  query getVendorReportActivities(
    $page: Int
    $limit: Int
    $revvUid: String
    $dateRangeStart: String
    $dateRangeEnd: String
    $reportRecurrence: ReportRecurrenceTypeEnum
    $reportType: ReportActivityTypeEnum
    $reportStatus: ReportStatusTypeEnum
    $organizationRevvUid: String
  ) {
    viewer {
      vendor(revvUid: $organizationRevvUid) {
        report_activity(
          filters: {
            page: $page
            limit: $limit
            revvUid: $revvUid
            dateRangeStart: $dateRangeStart
            dateRangeEnd: $dateRangeEnd
            reportRecurrence: $reportRecurrence
            reportType: $reportType
            reportStatus: $reportStatus
          }
        ) {
          ...ReportActivities
        }
      }
    }
  }
  ${exportFragment}
`;
